<div fxLayout="column" fxLayoutAlign="space-between">
  <div fxFlex>
    <h3 *ngIf="!dialogData.isReconnection">Connect a new {{ dialogData.integration_name }} account</h3>
    <h3 *ngIf="dialogData.isReconnection">Reconnect a {{ dialogData.integration_name }} account</h3>
  </div>

  <div fxLayout fxLayoutAlign="start start" fxLayoutGap="12px">
    <span class="domain__text">
      Please remove integrations with other property management software or booking channels (such as Airbnb) that would
      create codes to guests for the locks that you want to connect to Hospitable.
    </span>
  </div>

  <div fxLayout fxLayoutAlign="start start" fxLayoutGap="12px" *ngIf="dialogData.integration_name === 'SmartThings'">
    <span class="domain__text">
      Please be sure your account uses an email to login, and not SSO through a Google account.
    </span>
  </div>

  <div *ngIf="dialogData.isFirstConnection && !dialogData.isReconnection" class="warning" fxLayout fxLayoutGap="16px">
    <img src="assets/iconography/warning.svg" width="20px" height="20px" fxFlex="0 0 20px" />
    <span>
      Please do not attempt to connect a {{ dialogData.integration_name }} account that is already connected to
      Hospitable.
    </span>
  </div>

  <div fxLayoutAlign="end center" fxLayoutGap="8px" style="margin-top: 40px">
    <sbnb-button label="Connect" [loading]="loading" (clicked)="okClicked()"></sbnb-button>
  </div>

  <div *ngIf="dialogData.isFirstConnection" fxLayout="column" fxLayoutGap="18px" class="import-new-locks-message">
    <h3>Import new locks</h3>
    <span>
      If you added new locks to a {{ dialogData.integration_name }} account that is already connected to Hospitable, you
      don't need to take further action. New locks will appear automatically within 24 hours.
    </span>
  </div>
</div>
